import React, { Fragment, useEffect, useCallback, useState } from 'react';
import Spinner, { MiniSpinner } from '../layouts/Spinner';
import {
    setPage,
    getSingleBranch,
    updateFile,
    uploadFiles,
} from '../../redux/actions/branch/branch.actions';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { handleHover } from '../../redux/actions/helper/helper.actions';
import { useParams } from 'react-router-dom';
import DropDownAttachFileGlobal from '../layouts/DropDownAttachFile.global';
import DeliveryTable from '../delivery/Delivery.table';
import BranchDateFilterGlobal from './Branch.datefilter.global';

function BranchHistory({
    branch: {
        upload_loading,
        single_branch,
        main_url,
        mini_loading,
        edit_url,
        new_uploads,
        files_to_remove,
    },
    getSingleBranch,
    updateFile,
    uploadFiles,
    handleHover,
    isHover,
    hoverIndex,
}) {
    const { id } = useParams();

    const pageOrigin = {
        branch_id: id,
        origin: 'branch_history',
    };

    const [tab, setTab] = useState('deliveries');

    const onDrop = useCallback((acceptedFiles) => {
        updateFile(acceptedFiles);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    useEffect(() => {
        getSingleBranch(id, 'history');
    }, []);

    return (
        <div className="app-content content">
            <div className="content-wrapper max-1920 mx-auto">
                <div className="content-wrapper-before"></div>
                <div className="content-header row">
                    <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                        <h3 className="content-header-title mb-0 d-inline-block">
                            Inventory
                        </h3>
                        <div className="breadcrumbs-top d-inline-block">
                            <div className="breadcrumb-wrapper mr-1">
                                <ol className="breadcrumb f-regular">
                                    <li className="breadcrumb-item">
                                        <a href={main_url} className="text-white">
                                            Branches
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="#" className="text-white">
                                            History
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-body margin-top-5">
                    <section id="basic-examples">
                        <div className="row f-regular">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header mb-0 pb-0">
                                        <Link to={main_url}>
                                            <i className="ft ft-arrow-left"></i>{' '}
                                            Back
                                        </Link>

                                        <div className="float-right">
                                            <Link
                                                to={`${edit_url}/${id}`}
                                                className="btn btn-sm btn-grey"
                                            >
                                                <i className="ft ft-edit"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body f-regular">
                                            {mini_loading ? (
                                                <Spinner />
                                            ) : (
                                                <Fragment>
                                                    <section className="row">
                                                        <div className="col-lg-4">
                                                            <div className="mb-1">
                                                                <span><strong>Name: </strong></span>
                                                                {single_branch.name}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Business Name: </strong></span>
                                                                {single_branch.business_name}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Street 1: </strong></span>
                                                                {single_branch.street1 || single_branch.address}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Street 2: </strong></span>
                                                                {single_branch.street2}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>City: </strong></span>
                                                                {single_branch.city}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>State/Region: </strong></span>
                                                                {single_branch.state}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-1">
                                                                <span><strong>Country: </strong></span>
                                                                {single_branch.country ? single_branch.country.label : ''}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Fax: </strong></span>
                                                                {single_branch.fax}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Email: </strong></span>
                                                                {single_branch.email}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Landline: </strong></span>
                                                                {single_branch.landline}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Mobile: </strong></span>
                                                                {single_branch.mobile}
                                                            </div>
                                                            <div className="mb-1">
                                                                <span><strong>Contact Person: </strong></span>
                                                                {single_branch.contact_person}
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-4 col-sm-12 mb-2">
                                                            <DropDownAttachFileGlobal
                                                                origin="branch"
                                                                origin_data={single_branch}
                                                                new_uploads={new_uploads}
                                                                files_to_remove={files_to_remove}
                                                            />
                                                        </div>
                                                    </section>
                                                </Fragment>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="card-content collapse show">
                                    <div className="card-body no-padding-top no-padding-left-right">
                                        <ul className="nav nav-tabs">
                                            <li className="">
                                                <a
                                                    onClick={() => setTab('deliveries')}
                                                    className="nav-link active"
                                                    data-toggle="tab"
                                                    href="#tab-deliveries"
                                                >
                                                    Deliveries
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="tab-content px-1 card card-box-top">
                                            <div
                                                role="tabpanel"
                                                className="tab-pane active"
                                                id="tab-deliveries"
                                            >
                                                {tab === 'deliveries' && (
                                                    <>
                                                        <BranchDateFilterGlobal
                                                            filterBy="deliveries"
                                                            pageOrigin={pageOrigin}
                                                        />
                                                        <DeliveryTable
                                                            pageOrigin={pageOrigin}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    branch: state.branch,
    isHover: state.helper.isHover,
    hoverIndex: state.helper.hoverIndex,
});

export default connect(mapStateToProps, {
    getSingleBranch,
    setPage,
    updateFile,
    uploadFiles,
    handleHover,
})(BranchHistory);
